import styled from 'styled-components';

export const StyledProject = styled.div`
  z-index: 1000;
  height: 100%;

  @media screen and (max-width: 768px) {
    padding-top: 20px;
    padding-bottom: 35px;
  }

  h3, h5 {
    color:  #333;

    @media screen and (max-width: 768px) { 
      color: #333;
    }
  }
  p {
    color: white;
  }
  
  h3 {
    font-size: 24px;
    margin-bottom: 5px;
    @media screen and (min-width: 768px) {
      margin-top: 15px;
    }
  }

  .solo-indicator {

    font-size: 12px;
    border-radius: 25px;
    display: inline-block;
    padding: 0.2rem 0.8rem;
    margin-top: -10px;

    @media screen and (min-width: 768px) {
      border: solid 1px black;
      /* color: white;

      background-color: #222; */
    }

    @media screen and (max-width: 768px) {
      margin-bottom: 10px;
      font-weight: 500;
      font-size: 14px;
    }
  }

  main {
    display: flex;
    gap: 20px;
    padding: 20px 90px;
    z-index: 1000;
    
    @media screen and (max-width: 768px) {
      flex-direction: column;
      align-items: center;
      padding: 0;
    }

    .right {
      z-index: 1000;
      width: 100%;
      display: flex;
      flex-direction: column;
      @media screen and (max-width: 768px) {
        flex-direction: column-reverse;
        
      }
      align-items: center;
      justify-content: space-between;

      .stack {
        display: flex;
        
        gap: 20px;
        width: 100%;
      }

      .description {
        font-size: 14px;
        font-weight: 300;
      }

      .btns-container {
        width: 100%;
        display: flex;
        justify-content: center;
        gap: 50px;
        position: relative;
        top: 20px;
        z-index: 1000;
        @media screen and (max-width: 768px) {
          position: static;
          margin: 20px 0 35px;
        }
      }
    }
    .project-img {
      aspect-ratio: 1.0675;
      max-width: 35%;
      @media screen and (max-width: 768px) {
        width: 100%;
        max-width: 400px;
      }
    }
  }

`;

export const StyledButton = styled.button`
  max-height: 50px;
  font-size: 10px;
  border-radius: 5px;
  padding: 4px 0;
  background-color: #ddd;
  color: black;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 2px;
  border: 1px solid white;
  z-index: 1000;
  .github-logo {
    max-width: 25px;
  }

  &:hover {
    background-color: #fff;
    border: 1px solid black;
    transition: .5s;
  }
`;